export const worldlineSeVariables = {
	'font-higlight': 'Inter',
	'font-header': 'Inter',
	'font-body': 'Inter',
	'primary-100': '#E8F5F5',
	'primary-200': '#2D8C8C',
	'primary-400': '#2D8C8C',
	'primary-500': '#2D8C8C',
	'primary-700': '#277C7C',
	'secondary-100': '#E8F5F5',
	'secondary-200': '#58D2B5',
	'secondary-400': '#58D2B5',
	'secondary-500': '#58D2B5',
	'secondary-900': '#2D8C8C',

	'checkbox-100': '#E6E8E8',
	'checkbox-300': '#AAA',
	'checkbox-500': '#2D8C8C',
	'radio-100': '#E6E8E8',
	'radio-500': '#333333',

	'rounded-box': '16px',
	'rounded-notification': '0px',
	'min-width': 'fit-content',
	'highlight-light': '#E8F5F5',
	'highlight-border': '#1E1E1E',
	'slider-color': '#2D8C8C',
	'slider-border-color': '#1A1A1A',

	//Box card styles
	'box-background': '#E8F5F5',
	'box-info': '#1A1A1A',
	'box-border': '#1E1E1E',

	//Box card styles - secondary
	'box-background-light': '#EEEEEE',
	'box-info-light': '#1A1A1A',
	'box-border-light': '#FAFAFA',

	separator: '#BDBDBD',

	'input-phone-prefix': '#E4E4E4',

	spinner: '#2D8C8C',

	highlighted: '#1A1A1A',
	title: '#1A1A1A',
	paragraph: '#1A1A1A',

	dark: '#1E1E1E',
	brand: '#2D8C8C',

	'footer-background': '#E8F5F5',

	'common-padding': '16px',
	'common-margin': '16px',
	'common-gap': '32px',

	// BUTTON STYLES

	// primary button
	'button-color': '#2D8C8C',
	'button-color-hover': '#277C7C',
	'button-text': '#FFFFFF',
	'button-text-hover': '#FFFFFF',
	'rounded-button': '24px',
	'padding-button': '12px 24px',
	'border-button-color': '#2D8C8C',

	// secondary button
	'button-color-secondary': 'transparent',
	'button-text-secondary': '#000000',
	'button-text-secondary-hover': '#000000',
	'rounded-button-secondary': '24px',
	'padding-button-secondary-outlined': '10px 24px',
	'button-border-secondary-outlined': '#2D8C8C',
	'button-border-secondary-hover': '#2D8C8C',
	// --------------------------------------- //
};
